import './collapsible-header.scss'

import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const CollapsibleHeader = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        title: {},
        displayBottom: {
            type: Boolean,
            default: true,
        },
        statusMessage: {},
    },
    template: require("./collapsible-header.html"),
})
